<template>
  <div>
    <Layout/>
    <h4>Fecha Cita</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idFechaCita" class="form-label">IdFechaCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idFechaCita" name="idFechaCita" v-model="datoFechaCita.idFechaCita" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoFechaCita.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarFechaCita" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarFechaCita" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditFechaCita" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdHorario</th>
          <th scope="col">IdFechaCita</th>
          <th scope="col">IdEmpresa</th>
          <th scope="col">Hora Desde</th>
          <th scope="col">Hora Hasta</th>
          <th scope="col">Contador</th>
          <th scope="col">Estado</th>
          <th scope="col">FechaCitaFechaReg</th>
          <th scope="col">EmpresaNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="horario in datosPaginados" :key="horario.idHorario">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(horario.idHorario)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(horario.idHorario)" title="Editar">edit_square</i></td>
          <td>{{horario.idHorario}}</td>
          <td>{{horario.idFechaCita}}</td>
          <td>{{horario.idEmpresa}}</td>
          <td>{{horario.horaDesde}}</td>
          <td>{{horario.horaHasta}}</td>
          <td>{{horario.contador}}</td>
          <td>{{horario.estado}}</td>
          <td>{{getFormattedDate(horario.fechaCitaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{horario.empresaNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteFechaCita(horario.idHorario)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idHorario" class="form-label">IdHorario</label>
                </div>
                <div class="col-10">
                <input type="time" class="form-control" id="idHorario" name="idHorario" v-model="datoHorario.idHorario" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idFechaCita" class="form-label">IdFechaCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idFechaCita" name="idFechaCita" v-model="datoHorario.idFechaCita" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoHorario.idEmpresa"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresa" class="form-label"> Empresa</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="empresa" name="empresa" v-model="datoHorario.empresa" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEmpresaLOV"
                      title="Buscar Empresas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="horaDesde" class="form-label">HoraDesde</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="horaDesde" name="horaDesde" v-model="datoHorario.horaDesde" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="horaHasta" class="form-label">HoraHasta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="horaHasta" name="horaHasta" v-model="datoHorario.horaHasta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="contador" class="form-label">Contador</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="contador" name="contador" v-model="datoHorario.contador" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarHorario" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditHorario" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Horario -->
    <HorarioLOVdet @DatosHorario="GetDataHorarioLOVdet($event)"/>
<!-- Lista de Valores: Empresa -->
    <EmpresaLOVdet @DatosEmpresa="GetDataEmpresaLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
// Listas de valores master
// Listas de valores details
import HorarioLOVdet from '../../components/lovs/HorarioLOV.vue'
import EmpresaLOVdet from '../../components/lovs/EmpresaLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, HorarioLOVdet
, EmpresaLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      fechacitas : [],
      datoFechaCita : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idFechaCita: '',
// Variables master
// Variables details
      horarios : [],
      datoHorario : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idFechaCita = this.$route.params.p_idfechacita
    this.abrirEditar(this.p_idFechaCita)
    this.getHorarios()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoFechaCita.idFechaCita === ''){
        swal("Error!", "El elemento idFechaCita no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoFechaCita.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoFechaCita.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarFechaCita(){
      if(this.validarForm() === 1){
        try {
          await api.post('/fechacitas', this.datoFechaCita)
          swal("Correcto!", "FechaCita creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditFechaCita(){
      if(this.validarForm() === 1){
        try {
          await api.post('/fechacitas', this.datoFechaCita)
          swal("Correcto!", "FechaCita creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoFechaCita={}
      this.titulo   = 'Crear Fecha Cita'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idFechaCita){
      this.modalWindow = true
      if(idFechaCita != null){    
           api.get('/vwfechacitas/'+idFechaCita).then(resp=>{
          this.datoFechaCita = resp.data;
           });
      }
      this.titulo   = 'Editar Fecha Cita'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarFechaCita(){
      this.$router.push('/FechaCita')
    },
// Procedimientos master
// Procedimientos detalle
    async getHorarios() {
      const resp = await api.get('/horarios')
      this.horarios = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.horarios.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwhorarios/nombre/'+this.nombreBusqueda).then(response=>{
          this.horarios=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.horarios.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwhorarios').then(response=>{
      this.horarios=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.horarios.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoHorario.idFechaCita === ''){
        swal("Error!", "El elemento idFechaCita no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoHorario.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoHorario.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarHorario(){
      if(this.validarForm() === 1){
        try {
          this.datoHorario.idFechaCita = this.datoFechaCita.idFechaCita;
          await api.post('/horarios', this.datoHorario)
          this.getHorarios();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Horario creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditHorario(){
      if(this.validarForm() === 1){
        try {
          await api.post('/horarios', this.datoHorario)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Horario creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoHorario={}
      this.titulo   = 'Crear Fecha Cita'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idHorario){
      this.modalWindow = true
      if(idHorario != null){    
           api.get('/vwhorarios/'+idHorario).then(resp=>{
          this.datoHorario = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Fecha Cita'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idHorario){
      this.modalWindow = true
      if(idHorario != null){
        this.$router.push('/horariomd/'+idHorario)
      }
    },
    async deleteHorario (idHorario) {
      try{
        await api.delete('/horarios/'+idHorario)
          this.getHorarios()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataHorarioLOVdet(data) {
      this.datoHorario.idHorario = data.idHorario;
      this.datoHorario.horario = data.nombre;
    },
//    Lista de Valores
    GetDataEmpresaLOVdet(data) {
      this.datoHorario.idEmpresa = data.idEmpresa;
      this.datoHorario.empresa = data.nombre;
    },
// Listas de valores details
  },
}
</script>
